var mapStyle = [
  {
    "featureType": "water",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#e9e9e9"
      },
      {
        "lightness": 17
      }
    ]
  },
  {
    "featureType": "landscape",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#f5f5f5"
      },
      {
        "lightness": 20
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#ffffff"
      },
      {
        "lightness": 17
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "color": "#ffffff"
      },
      {
        "lightness": 29
      },
      {
        "weight": 0.2
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#ffffff"
      },
      {
        "lightness": 18
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#ffffff"
      },
      {
        "lightness": 16
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#f5f5f5"
      },
      {
        "lightness": 21
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#dedede"
      },
      {
        "lightness": 21
      }
    ]
  },
  {
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "visibility": "on"
      },
      {
        "color": "#ffffff"
      },
      {
        "lightness": 16
      }
    ]
  },
  {
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "saturation": 36
      },
      {
        "color": "#333333"
      },
      {
        "lightness": 40
      }
    ]
  },
  {
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "transit",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#f2f2f2"
      },
      {
        "lightness": 19
      }
    ]
  },
  {
    "featureType": "administrative",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#fefefe"
      },
      {
        "lightness": 20
      }
    ]
  },
  {
    "featureType": "administrative",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "color": "#fefefe"
      },
      {
        "lightness": 17
      },
      {
        "weight": 1.2
      }
    ]
  }
]

var googleMapsInited = false;
var mapContainer = document.getElementById('storeLocator-map');
var userLocation = false;
var userAddress = false;
var infoWindow;
var customWindow;
var map;

if (!googleMapsInited) {
    googleMapsInited = true;
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://maps.googleapis.com/maps/api/js?key=' + window.googleMaps.apiKey + '&libraries=places&callback=initMap&solution_channel=GMP_codelabs_simplestorelocator_v1_a';
    document.head.appendChild(script);
}

function getCurrentTimeCET() {
  var timeOptions = {
      timeZone: 'Europe/Berlin',
      weekday: 'long',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
    },
    formatter = new Intl.DateTimeFormat([], timeOptions);
  var timeNow = formatter.format(new Date());//.replace(/([0-9]*)\/([0-9]*)\/([0-9]*),(.*)/g,'$3$2$1$4').replace(/[^0-9.]+/g, '');
  return timeNow;
}

function generateWeekdayNamesArray() {
  const weekdayDateMap = {
    Mon: new Date('2020-01-06T00:00:00.000Z'),
    Tue: new Date('2020-01-07T00:00:00.000Z'),
    Wed: new Date('2020-01-08T00:00:00.000Z'),
    Thu: new Date('2020-01-09T00:00:00.000Z'),
    Fri: new Date('2020-01-10T00:00:00.000Z'),
    Sat: new Date('2020-01-11T00:00:00.000Z'),
    Sun: new Date('2020-01-12T00:00:00.000Z'),
  };
  const shortWeekdays = Object.keys(weekdayDateMap);
  const getDayOfWeek = (shortName, locale = Shopify.locale, length = 'long') => new Intl.DateTimeFormat(locale, { weekday: length }).format(weekdayDateMap[shortName]);
  return shortWeekdays.map(shortName => getDayOfWeek(shortName))
}

function checkIfOpened(openingHours) {
  var dateNow = getCurrentTimeCET();
  var daysOfTheWeek = generateWeekdayNamesArray();

  var timeArray = dateNow.split(',');

  var weekdayNameNow = timeArray[0].trim();
  var timeNow = parseInt(timeArray[2].replace(':', '').trim());

  var weekdayNow = daysOfTheWeek.indexOf(weekdayNameNow);

  var openedToday = openingHours[weekdayNow];
  if( openedToday ) {
    var openingArray = openedToday.split('-');
    var openingStart = parseInt(openingArray[0].replace(':', '').trim());
    var openingEnd = parseInt(openingArray[1].replace(':', '').trim());
    return timeNow > openingStart && timeNow < openingEnd
  } else {
    return false
  }
}

function renderOpeningHours(openingHours) {
  var daysOfTheWeek = generateWeekdayNamesArray();
  var returnHTML = ''
  daysOfTheWeek.forEach(function(day, i){
    returnHTML += `<div class="weekday">${day}: ${openingHours[i] != 'false' ? openingHours[i] : theme.storeLocator.closed}</div>`
  })
  return returnHTML
}

function generateRouteLink(destination) {
  var link = 'https://www.google.com/maps/dir/';
  var from = '';
  if (userAddress) {
    from = userAddress;
  }
  link = link + from + '/' + destination
  return link
}

function colorMarkers(map) {
  map.data.setStyle((feature) => {
    var finalMarkerUrl = theme.storeLocator.markerGrayUrl;
    if (feature.getProperty('visible')) {
      finalMarkerUrl = theme.storeLocator.markerUrl
    }
    return {
      icon: {
        url: finalMarkerUrl,
        scaledSize: new google.maps.Size(32, 32),
      },
    };
  });
}

function showMessage(infoWindow, map, store) {
  const name = store.getProperty('name');
  const address = store.getProperty('address');
  const distance = store.getProperty('distanceText');
  const mapLink = store.getProperty('map_link');
  const position = store.getGeometry().get();
  const distanceEl = distance ? '<div class="store-popup__distance"><span>' + distance + '</span></div>' : '';
  const content = `
  <div class="store-popup">
      <div class="store-popup__inner">
          <div class="store-popup__data">
              <h2 class="store-popup__name">${name}</h2>
              <p class="store-popup__address">${address}</p>
              <a target="_blank" rel="noopener" href="${mapLink}" class="store-popup__route">
                ${theme.storeLocator.routeBtn}
              </a>              
          </div>
          ${distanceEl}
      </div>
  </div>
  `;
  infoWindow.setContent(content);
  infoWindow.setPosition(position);
  infoWindow.setOptions({
    disableAutoPan: true
  });
  const newPosition = {
    lat: position.lat(),
    lng: position.lng() + (10 / map.getZoom())
  }
  infoWindow.open(map);
  map.setCenter(newPosition);
}


document.body.addEventListener('click', function(e){
  if( e.target.classList.contains('store-popup__opening-hours--trigger') ) {
    e.preventDefault();
    e.target.closest('.store-popup').parentNode.querySelector('.store-popup__opening-hours--popup').classList.add('opened');
  }
  if( e.target.classList.contains('store-popup__opening-hours--popup-close') ) {
    e.preventDefault();
    e.target.parentNode.classList.remove('opened');
  }
});

function initMap() {
  // Create the map.
  // Assign first marker
	const firstMarker = theme.storeLocator.storeData.features[0];

  // Create the map.
  var mapCenter = theme.storeLocator.center;

  map = new google.maps.Map(mapContainer, {
    zoom: 7,
    center: mapCenter,
    styles: mapStyle
  });

  // Load the stores GeoJSON onto the map.
  //map.data.loadGeoJson('stores.json', {idPropertyName: 'storeid'});
  map.data.addGeoJson(theme.storeLocator.storeData, { idPropertyName: 'storeid' });

  // Define the custom marker icons, using the store's "category".

  colorMarkers(map);

  infoWindow = new google.maps.InfoWindow()

  google.maps.event.addListener(infoWindow, 'closeclick', function () {
    map.data.forEach(function (mapData) {
      mapData.setProperty('visible', false);
    });
    colorMarkers(map);
  });


  // Show the information for a store when its marker is clicked.
  map.data.addListener('click', (event) => {

    map.data.forEach(function (mapData) {
      mapData.setProperty('visible', false);
    });
    event.feature.setProperty('visible', true);

    colorMarkers(map);
    showMessage(infoWindow, map, event.feature);
  });

  // Build and add the search bar
  const card = document.getElementById('storeLocator-data');

  const inputWrap = document.createElement('div');
  inputWrap.classList.add('store__search');

  const searchIcon = document.createElement('div');
  searchIcon.classList.add('store__search-icon');
  searchIcon.innerHTML = `<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M26.5068 27.3483C27.0513 27.8898 27.8919 27.054 27.3473 26.5242L22.9079 22.0979C24.4651 20.3844 25.3259 18.1564 25.3229 15.8468C25.3229 10.6789 21.0966 6.4762 15.8995 6.4762C10.7024 6.4762 6.47607 10.6789 6.47607 15.8468C6.47607 21.0148 10.7024 25.2175 15.8995 25.2175C18.2435 25.2175 20.41 24.3581 22.0673 22.9337L26.5068 27.3483ZM7.65874 15.8468C7.65874 11.3263 11.3642 7.65341 15.8983 7.65341C20.4443 7.65341 24.1379 11.3263 24.1379 15.8468C24.1379 20.3674 20.4443 24.0403 15.8983 24.0403C11.3642 24.0403 7.65874 20.3674 7.65874 15.8468Z" fill="#333333"/>
  </svg>`;

  const input = document.createElement('input');
  input.setAttribute('type', 'text');
  input.setAttribute('placeholder', theme.storeLocator.enterAddress);
  input.classList.add('store__search-input');
  //input.value = 'Jens Kofods Gade 1, 1268 København, Denmark';

  const options = {
    types: ['address'],
    //componentRestrictions: {country: 'gb'},
  };

  const storeListWrap = document.createElement('ul');
  storeListWrap.classList.add('store__list');
  storeListWrap.setAttribute('id', 'storeLocator-list');

  inputWrap.appendChild(input);
  inputWrap.appendChild(searchIcon);
  card.appendChild(inputWrap);
  card.appendChild(storeListWrap);

  // Make the search bar into a Places Autocomplete search bar and select
  // which detail fields should be returned about the place that
  // the user selects from the suggestions.
  const autocomplete = new google.maps.places.Autocomplete(input, options);

  autocomplete.setFields(
    ['address_components', 'geometry', 'name']);

  // Set the origin point when the user selects an address
  const originMarker = new google.maps.Marker({ map: map });
  originMarker.setVisible(false);
  let originLocation = map.getCenter();

  async function setInitialLocation(){
    originLocation = {
      "lat": theme.storeLocator.center.lat,
      "lng": theme.storeLocator.center.lng
    }
    userAddress = input.value;
    userLocation = {
      "lat": theme.storeLocator.center.lat,
      "lng": theme.storeLocator.center.lng
    };
    originMarker.setPosition(userLocation);
    const rankedStores = await calculateDistances(map.data, originLocation);
    showStoresList(map.data, rankedStores);
  }
  setInitialLocation();


  autocomplete.addListener('place_changed', async () => {
    //originMarker.setVisible(false);
    originLocation = map.getCenter();
    const place = autocomplete.getPlace();
    if (place && place.geometry && place.geometry.location) {
      userAddress = input.value;
      userLocation = place.geometry.location;
      originMarker.setPosition(userLocation);

      //originMarker.setVisible(true);
    }

    // Recenter the map to the selected address
    //originLocation = place.geometry.location;

    const rankedStores = await calculateDistances(map.data, originLocation);
    showStoresList(map.data, rankedStores);
    return;
  });
}

/**
 * Use Distance Matrix API to calculate distance from origin to each store.
 * @param {google.maps.Data} data The geospatial data object layer for the map
 * @param {google.maps.LatLng} origin Geographical coordinates in latitude
 * and longitude
 * @return {Promise<object[]>} n Promise fulfilled by an array of objects with
 * a distanceText, distanceVal, and storeid property, sorted ascending
 * by distanceVal.
 */
async function calculateDistances(data, origin) {
  const stores = [];
  const destinations = [];

  // Build parallel arrays for the store IDs and destinations
  data.forEach((store) => {
    const storeNum = store.getProperty('storeid');
    const storeLoc = store.getGeometry().get();
    stores.push(storeNum);
    destinations.push(storeLoc);
  });

  // Retrieve the distances of each store from the origin
  // The returned list will be in the same order as the destinations list
  const service = new google.maps.DistanceMatrixService();
  const getDistanceMatrix =
    (service, parameters) => new Promise((resolve, reject) => {
      service.getDistanceMatrix(parameters, (response, status) => {
        if (status != google.maps.DistanceMatrixStatus.OK) {
          reject(response);
        } else {
          const distances = [];
          const results = response.rows[0].elements;
          for (let j = 0; j < results.length; j++) {
            const element = results[j];
            if (element.distance) {
              const distanceText = element.distance.text;
              const distanceVal = element.distance.value;
              const distanceObject = {
                storeid: stores[j],
                distanceText: distanceText,
                distanceVal: distanceVal,
              };
              distances.push(distanceObject);
            }
          }

          resolve(distances);
        }
      });
    });

  const distancesList = await getDistanceMatrix(service, {
    origins: [origin],
    destinations: destinations,
    travelMode: 'DRIVING',
    unitSystem: google.maps.UnitSystem.METRIC,
  });

  distancesList.sort((first, second) => {
    return first.distanceVal - second.distanceVal;
  });

  return distancesList;
}



/**
 * Build the content of the side panel from the sorted list of stores
 * and display it.
 * @param {google.maps.Data} data The geospatial data object layer for the map
 * @param {object[]} stores An array of objects with a distanceText,
 * distanceVal, and storeid property.
 */
function showStoresList(data, stores) {
  if (stores.length == 0) {
    return;
  }

  let panel = document.getElementById('storeLocator-list');

  // Clear the previous details
  while (panel.lastChild) {
    panel.removeChild(panel.lastChild);
  }

  stores.forEach((store, i) => {
    // Add store details with text formatting
    const storeElement = document.createElement('div');
    storeElement.classList.add('store')

    var distance = store.distanceText;
    const currentStore = data.getFeatureById(store.storeid);
    const name = currentStore.getProperty('name');
    const address = currentStore.getProperty('address');
    const phoneNumber = currentStore.getProperty('phoneNumber');
    const openingHours = currentStore.getProperty('openingHours');
    const position = currentStore.getGeometry().get();

    currentStore.setProperty('distanceText', distance);
    storeElement.setAttribute('data-position', position);

    const content = `
          <div class="store__inner">
              <div class="store__data">
                  <h2 class="store-name">${name}</h2>
                  <p class="store-address"></p>
              </div>
              <div class="store__distance">
                <div class="store__distance-icon">
                  <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M14.8438 16.625H11.1729C11.7895 16.0744 12.3711 15.4857 12.9141 14.8623C14.9514 12.5192 16.0312 10.0492 16.0312 7.71875C16.0312 5.98656 15.3431 4.32531 14.1183 3.10046C12.8934 1.87561 11.2322 1.1875 9.5 1.1875C7.76781 1.1875 6.10656 1.87561 4.88171 3.10046C3.65686 4.32531 2.96875 5.98656 2.96875 7.71875C2.96875 10.0492 4.04566 12.5192 6.08594 14.8623C6.62893 15.4857 7.21046 16.0744 7.82711 16.625H4.15625C3.99878 16.625 3.84776 16.6876 3.73641 16.7989C3.62506 16.9103 3.5625 17.0613 3.5625 17.2188C3.5625 17.3762 3.62506 17.5272 3.73641 17.6386C3.84776 17.7499 3.99878 17.8125 4.15625 17.8125H14.8438C15.0012 17.8125 15.1522 17.7499 15.2636 17.6386C15.3749 17.5272 15.4375 17.3762 15.4375 17.2188C15.4375 17.0613 15.3749 16.9103 15.2636 16.7989C15.1522 16.6876 15.0012 16.625 14.8438 16.625ZM9.5 5.34375C9.96973 5.34375 10.4289 5.48304 10.8195 5.74401C11.21 6.00498 11.5145 6.3759 11.6942 6.80988C11.874 7.24385 11.921 7.72138 11.8294 8.18209C11.7377 8.64279 11.5115 9.06598 11.1794 9.39813C10.8472 9.73028 10.424 9.95648 9.96334 10.0481C9.50263 10.1398 9.0251 10.0927 8.59113 9.91296C8.15715 9.73321 7.78623 9.4288 7.52526 9.03823C7.26429 8.64766 7.125 8.18848 7.125 7.71875C7.125 7.08886 7.37522 6.48477 7.82062 6.03937C8.26602 5.59397 8.87011 5.34375 9.5 5.34375Z" fill="#899C80"/>
                  </svg>
                </div>
                <span>${distance}</span>
              </div>
          </div>
      `;

    storeElement.innerHTML = content;
    storeElement.querySelector('.store-address').innerHTML = address;

    let storeVisitBtn = document.createElement('a');
    storeVisitBtn.classList.add('store-visit');
    storeVisitBtn.href = '#';
    storeVisitBtn.innerHTML = theme.storeLocator.visitBtn;

    storeVisitBtn.addEventListener('click', function (e) {
      e.preventDefault();

      currentStore.setProperty('visible', true);
      colorMarkers(map);
      showMessage(infoWindow, map, currentStore);
    });

    storeElement.appendChild(storeVisitBtn)
    panel.appendChild(storeElement);

    if (i == 0) {
      storeVisitBtn.click()
    }
  });

  return;
}


// var mapStyle = [
//   {
//       "featureType": "water",
//       "elementType": "geometry",
//       "stylers": [
//           {
//               "color": "#e9e9e9"
//           },
//           {
//               "lightness": 17
//           }
//       ]
//   },
//   {
//       "featureType": "landscape",
//       "elementType": "geometry",
//       "stylers": [
//           {
//               "color": "#f5f5f5"
//           },
//           {
//               "lightness": 20
//           }
//       ]
//   },
//   {
//       "featureType": "road.highway",
//       "elementType": "geometry.fill",
//       "stylers": [
//           {
//               "color": "#ffffff"
//           },
//           {
//               "lightness": 17
//           }
//       ]
//   },
//   {
//       "featureType": "road.highway",
//       "elementType": "geometry.stroke",
//       "stylers": [
//           {
//               "color": "#ffffff"
//           },
//           {
//               "lightness": 29
//           },
//           {
//               "weight": 0.2
//           }
//       ]
//   },
//   {
//       "featureType": "road.arterial",
//       "elementType": "geometry",
//       "stylers": [
//           {
//               "color": "#ffffff"
//           },
//           {
//               "lightness": 18
//           }
//       ]
//   },
//   {
//       "featureType": "road.local",
//       "elementType": "geometry",
//       "stylers": [
//           {
//               "color": "#ffffff"
//           },
//           {
//               "lightness": 16
//           }
//       ]
//   },
//   {
//       "featureType": "poi",
//       "elementType": "geometry",
//       "stylers": [
//           {
//               "color": "#f5f5f5"
//           },
//           {
//               "lightness": 21
//           }
//       ]
//   },
//   {
//       "featureType": "poi.park",
//       "elementType": "geometry",
//       "stylers": [
//           {
//               "color": "#dedede"
//           },
//           {
//               "lightness": 21
//           }
//       ]
//   },
//   {
//       "elementType": "labels.text.stroke",
//       "stylers": [
//           {
//               "visibility": "on"
//           },
//           {
//               "color": "#ffffff"
//           },
//           {
//               "lightness": 16
//           }
//       ]
//   },
//   {
//       "elementType": "labels.text.fill",
//       "stylers": [
//           {
//               "saturation": 36
//           },
//           {
//               "color": "#333333"
//           },
//           {
//               "lightness": 40
//           }
//       ]
//   },
//   {
//       "elementType": "labels.icon",
//       "stylers": [
//           {
//               "visibility": "off"
//           }
//       ]
//   },
//   {
//       "featureType": "transit",
//       "elementType": "geometry",
//       "stylers": [
//           {
//               "color": "#f2f2f2"
//           },
//           {
//               "lightness": 19
//           }
//       ]
//   },
//   {
//       "featureType": "administrative",
//       "elementType": "geometry.fill",
//       "stylers": [
//           {
//               "color": "#fefefe"
//           },
//           {
//               "lightness": 20
//           }
//       ]
//   },
//   {
//       "featureType": "administrative",
//       "elementType": "geometry.stroke",
//       "stylers": [
//           {
//               "color": "#fefefe"
//           },
//           {
//               "lightness": 17
//           },
//           {
//               "weight": 1.2
//           }
//       ]
//   }
// ]
//
// var googleMapsInited = false;
// var mapPopup = document.querySelector('#storeLocatorPopup');
// var mapContainer = document.getElementById('storeLocator-map');
// var userLocation = false;
// var userAddress = false;
// var infoWindow;
// var customWindow;
// var map;
//
//
// if (!googleMapsInited) {
//     googleMapsInited = true;
//     var script = document.createElement('script');
//     script.type = 'text/javascript';
//     script.src = 'https://maps.googleapis.com/maps/api/js?key=' + window.googleMaps.apiKey + '&libraries=places&callback=initMap&solution_channel=GMP_codelabs_simplestorelocator_v1_a';
//     document.head.appendChild(script);
// }
//
// function colorMarkers(map) {
//   map.data.setStyle((feature) => {
//
//       var finalMarkerUrl = theme.storeLocator.markerGrayUrl;
//       if (feature.getProperty('visible')) {
//           finalMarkerUrl = theme.storeLocator.markerUrl
//       }
//       return {
//           icon: {
//               url: finalMarkerUrl,
//               scaledSize: new google.maps.Size(32, 32),
//           },
//       };
//   });
// }
//
// function showMessage(infoWindow, map, store) {
//   const name = store.getProperty('name');
//   const address = store.getProperty('address');
//   const position = store.getGeometry().get();
//   const content = `
//   <div class="store-popup">
//       <div class="store-popup__inner">
//           <div class="store-popup__data">
//               <h2 class="store-popup__name">${name}</h2>
//               <p class="store-popup__address">${address}</p>
//           </div>
//       </div>
//   </div>
//   `;
//   infoWindow.setContent(content);
//   infoWindow.setPosition(position);
//   infoWindow.setOptions({
//       disableAutoPan: true
//   });
//   const newPosition = {
//       lat: position.lat(),
//       lng: position.lng() + (10 / map.getZoom())
//   }
//   infoWindow.open(map);
//   map.setCenter(newPosition);
// }
//
//
// function initMap() {
// 	//   Assign markers
// 	const markerNodes = document.querySelectorAll('[data-marker]');
// 	let markers = [];
// 	for (const item of markerNodes) {
// 			const [name, lat, lon] = item.getAttribute('data-marker').split(',');
// 			markers.push([name, +lat, +lon, item.getAttribute('data-store-id')]);
// 	}
//
// 	//   Assign first marker
// 	const firstMarker = markers[0];
// 	const [_, locationLat, locationLng] = firstMarker;
//
//   // Create the map.
//   var mapCenter = { lat: locationLat, lng: locationLng };
//   map = new google.maps.Map(mapContainer, {
//       zoom: 7,
//       center: mapCenter,
//       styles: mapStyle,
//       disableDefaultUI: true
//   });
//
//   // Load the stores GeoJSON onto the map.
//   //map.data.loadGeoJson('stores.json', {idPropertyName: 'storeid'});
//   map.data.addGeoJson(theme.storeLocator.storeData, { idPropertyName: 'storeid' });
//
//   // Define the custom marker icons, using the store's "category".
//
//   colorMarkers(map);
//
//   infoWindow = new google.maps.InfoWindow()
//
//   google.maps.event.addListener(infoWindow, 'closeclick', function () {
//       map.data.forEach(function (mapData) {
//           mapData.setProperty('visible', false);
//       });
//       colorMarkers(map);
//   });
//
//   // Show the information for a store when its marker is clicked.
//   // this doesnt work for some reason
//   // map.data.addListener('click', (event) => {
//   //     map.data.forEach(function (mapData) {
//   //         mapData.setProperty('visible', false);
//   //     });
//   //     event.feature.setProperty('visible', true);
//   //
//   //     colorMarkers(map);
//   //     showMessage(infoWindow, map, event.feature);
//   // });
//
//   const card = document.getElementById('storeLocator-data');
//   const options = {
//       types: ['address'],
//       //componentRestrictions: {country: 'gb'},
//   };
//
//   const storeListWrap = document.createElement('ul');
//   storeListWrap.classList.add('store__list');
//   storeListWrap.setAttribute('id', 'storeLocator-list');
//
// //   card.appendChild(storeListWrap);
//
// 	let bounds = new google.maps.LatLngBounds();
//
// 	// Place markers
// 	for (let index = 0; index < markers.length; index++) {
// 			const position = new google.maps.LatLng(markers[index][1], markers[index][2]);
// 			bounds.extend(position);
// 			marker = new google.maps.Marker({
// 					position,
// 					map,
// 					title: markers[index][0],
// 					icon: theme.storeLocator.markerUrl
// 			})
//
//       marker.addListener('click', e => {
//         window.theme.storeLocator.storeData.features.forEach(feature => {
//           if (markers[index][3] == feature.properties.storeid) {
//             map.data.forEach(function (mapData) {
//                 mapData.setProperty('visible', false);
//             });
//             //marker.setProperty('visible', true);
//
//             colorMarkers(map);
//             showMessage(infoWindow, map, feature);
//           }
//         });
//       });
//
// 			const element = markers[index];
//
// 	}
//
//   // Set the origin point when the user selects an address
//   const originMarker = new google.maps.Marker({ map: map });
//   originMarker.setVisible(false);
//   let originLocation = map.getCenter();
//
//   async function setInitialLocation(){
//     const firstMarker = markers[0];
//     const [_, locationLat, locationLng] = firstMarker;
//
//
//     originLocation = {
//       "lat": locationLat,
//       "lng": locationLng
//     }
//     userLocation = {
//       "lat": locationLat,
//       "lng": locationLng
//     };
//     originMarker.setPosition(userLocation);
//     showStoresList(map.data, []);
//   }
//
//   setInitialLocation();
// }
//
// /**
// * Build the content of the side panel from the sorted list of stores
// * and display it.
// * @param {google.maps.Data} data The geospatial data object layer for the map
// * @param {object[]} stores An array of objects with a distanceText,
// * distanceVal, and storeid property.
// */
// function showStoresList(data, stores) {
//   if (stores.length == 0) {
//       return;
//   }
//
//   let panel = document.getElementById('storeLocator-list');
//
//   // Clear the previous details
//   while (panel.lastChild) {
//       panel.removeChild(panel.lastChild);
//   }
//
//   stores.forEach((store, i) => {
//       // Add store details with text formatting
//       const storeElement = document.createElement('div');
//       storeElement.classList.add('store')
//
//       const currentStore = data.getFeatureById(store.storeid);
//       const name = currentStore.getProperty('name');
//       const address = currentStore.getProperty('address');
//       const position = currentStore.getGeometry().get();
//
//       storeElement.setAttribute('data-position', position);
//
//       const content = `
//           <div class="store__inner">
//               <div class="store__data">
//                   <h2 class="store-name">${name}</h2>
//                   <p class="store-address">${address}</p>
//               </div>
//           </div>
//       `;
//
//       let storeVisitBtn = document.createElement('a');
//       storeVisitBtn.classList.add('store-visit');
//       storeVisitBtn.href = '#';
//       storeVisitBtn.innerHTML = theme.storeLocator.visitBtn;
//
//       storeVisitBtn.addEventListener('click', function () {
//           currentStore.setProperty('visible', true);
//           colorMarkers(map);
//           showMessage(infoWindow, map, currentStore);
//       });
//
//       storeElement.innerHTML = content;
//       storeElement.appendChild(storeVisitBtn)
//       panel.appendChild(storeElement);
//
//       if (i == 0) {
//           storeVisitBtn.click()
//       }
//   });
//
//   return;
// }
